import React from "react";

import { SafeLink } from "~/components/ui/safe-link";
import ICFBPLogoUrl from "~/img/icfbp-logo.svg";
import { cn } from "~/lib/cn";
import { ICF_PARTNER_URL } from "~/lib/constants/socials";

export const IcfPartnerBox = ({ className }: { className?: string }) => {
  return (
    <div className={cn("flex flex-col items-stretch", className)}>
      <img
        src={ICFBPLogoUrl}
        width={280}
        height={89}
        className="mb-4"
        alt="International Coaching Federation Business Solutions Partner badge"
      />
      <h3 className="text-text-primary mb-4 font-heading text-lg leading-tight font-medium tracking-tight">
        Dream Coach Match is proud to be a Business Partner of the{" "}
        <SafeLink
          href={ICF_PARTNER_URL}
          className="text-brand-700 underline hover:no-underline"
        >
          International Coaching Federation (ICF)
        </SafeLink>
        .
      </h3>
      <p className="text-text-secondary text-sm">
        The ICF is the world's largest network of trained coaching
        professionals, with over 55,000 certified coaches across 158 countries.
        Together, we're advancing the coaching profession and connecting you
        with trusted, top-tier coaches.
      </p>
    </div>
  );
};
